import CustomSelect from './CustomSelect';

export type { CustomSelectProps } from './types';
export default CustomSelect;
